import script from "./ScrollToTopButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollToTopButton.vue?vue&type=script&setup=true&lang=js"

import "./ScrollToTopButton.vue?vue&type=style&index=0&id=1e63cd62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e63cd62"]])

export default __exports__